import React from 'react'
import { ToggleTypes, useWidgetContext } from '../../../context/WidgetContext'
import { MainButton } from '../../common/button/MainButton'

export const MainActions = () => {
  const { toggle, isDocActive, isApiActive, isAIOpen, agent, mode } = useWidgetContext()

  const hasDocs = !!agent.docUrl
  const hasApiDocs = !!agent.apiDocUrl

  const supportType = agent.support?.type
  const supportValue = agent.support?.value?.trim()
  const hasSupportEmail = supportType === 'email' && !!supportValue
  const hasSupportPage = supportType === 'page' && !!supportValue
  const hasSupport = hasSupportEmail || hasSupportPage

  const normalizeUrl = (url: string) => {
    // if someone enters "example.com", make it https://example.com
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`
    }
    return url
  }

  const aiLabel =
    mode === 'search'
      ? 'Search'
      : mode === 'code'
        ? 'Edit Code'
      : mode === 'image'
        ? 'Generate Image'
        : mode === 'video'
          ? 'Generate Video'
        : mode === 'speech'
          ? 'Speech Chat'
          : 'Ask AI'

  const aiIcon =
    mode === 'search'
      ? 'search'
      : mode === 'code'
        ? 'code-slash'
      : mode === 'image'
        ? 'image'
        : mode === 'video'
          ? 'camera-video'
          : mode === 'speech'
            ? 'mic'
            : 'chat-dots'

  return (
    <div className="osirus-agent-btn-group">
      {/* Ask AI (placeholder bootstrap icon) */}
      {agent.isAiEnabled && (
        <MainButton
          bootstrapIcon={aiIcon}
          // iconName="roagent" // keep if you still want legacy icons as a fallback
          onClick={() => toggle(ToggleTypes.ai)}
          isActive={isAIOpen}
          label={aiLabel}
        />
      )}

      {/* Docs (placeholder bootstrap icon) */}
      {hasDocs && (
        <MainButton
          bootstrapIcon="journal-text"
          // iconName="journal-bookmark"
          onClick={() => toggle(ToggleTypes.doc)}
          isActive={isDocActive}
          label="Docs"
        />
      )}

      {/* API (placeholder bootstrap icon) */}
      {hasApiDocs && (
        <MainButton
          bootstrapIcon="code-slash"
          // iconName="headset"
          onClick={() => toggle(ToggleTypes.api)}
          isActive={isApiActive}
          label="API"
        />
      )}

      {/* Support (placeholder bootstrap icon) */}
      {hasSupport && (
        <MainButton
          bootstrapIcon="headset"
          // iconName="headset-vr"
          onClick={() => {
            if (!supportValue) return

            if (supportType === 'email') {
              // basic email sanity check – avoid obviously invalid values
              if (supportValue.includes('@')) {
                window.location.href = `mailto:${supportValue}`
              } else {
                console.warn('Support email is not a valid email address:', supportValue)
              }
              return
            }

            if (supportType === 'page') {
              const url = normalizeUrl(supportValue)
              const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
              if (newWindow) newWindow.opener = null
            }
          }}
          isActive={false}
          label="Support"
        />
      )}

      {/* Custom options (use bootstrap icon from payload if present) */}
      {agent.customOptions?.map((button, key) => (
        <MainButton
          key={key}
          bootstrapIcon={button.icon?.trim() || 'link-45deg'} // payload example: "telephone-plus"
          onClick={() => {
            if (!button.link) return

            if (button.openNewTab) {
              const newWindow = window.open(button.link, '_blank', 'noopener,noreferrer')
              if (newWindow) newWindow.opener = null
            } else {
              window.location.href = button.link
            }
          }}
          isActive={false}
          label={button.label}
        />
      ))}
    </div>
  )
}
